var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 37,
    viewBox: "0 0 44 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.22958 16.2056C3.22958 16.2056 22.4376 8.32569 29.1016 5.54223C31.6496 4.44453 40.3127 0.876995 40.3127 0.876995C40.3127 0.876995 44.3111 -0.691169 43.9583 3.11158C43.8407 4.67973 42.9783 10.0898 42.0767 15.9704C40.7439 24.2816 39.2936 33.416 39.2936 33.416C39.2936 33.416 39.0583 35.9642 37.1767 36.3955C35.2951 36.8267 32.1983 34.8273 31.6103 34.3961C31.1791 34.0825 23.3 29.0644 20.3992 26.6337C19.6152 25.9673 18.7527 24.6344 20.5167 23.0662C24.5151 19.4203 29.2976 14.8335 32.1592 11.9716C33.492 10.6387 34.8247 7.5416 29.2583 11.3051C21.3791 16.7544 13.6176 21.8509 13.6176 21.8509C13.6176 21.8509 11.8536 22.9486 8.52158 21.9685C5.18958 20.9884 1.30872 19.6555 1.30872 19.6555C1.30872 19.6555 -1.31762 18.009 3.22958 16.2056Z",
    fill: "white"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/Telegram.86ad3ac628aabdbb91a3a626e51baf05.svg";
export { ForwardRef as ReactComponent };